import React, { useEffect, useState } from "react";
import { InputAdornment, TextField, Typography } from "@mui/material";
import { colors } from "../theme/theme";

interface TextInputProps {
  label: string;
  value: string | number;
  onChange: (value: string) => void;
  disabled?: boolean;
  error?: string | null;
  multiline?: boolean;
  rows?: number;
  maxLength?: number;
  onFocus?: (
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  onBlur?: (
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  required?: boolean;
  inputPropsStyle?: React.CSSProperties;
  isCost?: boolean;
}
const TextBox: React.FC<TextInputProps> = ({
  label,
  value,
  onChange,
  disabled,
  error,
  multiline = false,
  rows,
  maxLength,
  isCost = false,
  onFocus,
  onBlur,
  required = false,
  inputPropsStyle = {},
  ...props
}) => {
  const [inputValue, setInputValue] = useState(value || "");

  useEffect(() => {
    // When initial props value changes, update state accordingly
    setInputValue(value || "");
  }, [value]);

  const handleInputChange = (e: any) => {
    let value = e.target.value;
    const trimmedValue = value.trimStart();
    if (trimmedValue === "") {
      setInputValue("");
    } else if (isCost) {
      let numericValue = trimmedValue.replace(/[^0-9.]/g, "");
      setInputValue(numericValue);
    } else {
      setInputValue(trimmedValue);
    }
    onChange(trimmedValue);
  };
  const handleInputBlur = (e: any) => {
    const trimmedValue = e.target.value.trim();
    if (isCost) {
      const numericValue = trimmedValue.replace(/^0+(?=\d)/, "");
      setInputValue(numericValue);
      onChange(numericValue);
    } else {
      setInputValue(trimmedValue);
      onChange(trimmedValue);
    }
    if (onBlur) {
      onBlur(e);
    }
  };
  return (
    <div className="form-field">
      {label && (
        <Typography
          className="typography-text"
          sx={{
            fontFamily: '"Inter", sans-serif',
            fontSize: "12px",
            fontWeight: 400,
            color: colors.primary,
            width: "80%",
          }}
          variant="subtitle2"
        >
          {label}
          {required && (
            <span style={{ color: "red", marginLeft: "4px" }}>*</span>
          )}
        </Typography>
      )}
      <TextField
        size="small"
        className="text-field"
        sx={{ marginBottom: "0px", marginTop: "8px" }}
        margin="normal"
        value={inputValue}
        onChange={handleInputChange}
        disabled={disabled}
        multiline={multiline}
        rows={rows}
        onFocus={onFocus}
        onBlur={handleInputBlur}
        inputProps={{
          maxLength,
          style: {
            fontSize: "14px",
            fontWeight: 400,
            fontFamily: '"Inter", sans-serif',
            ...inputPropsStyle,
          },
        }}
        {...props}
        InputProps={
          isCost
            ? {
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }
            : {}
        }
      />
      {error && (
        <Typography color="error" variant="body2">
          {error}
        </Typography>
      )}
    </div>
  );
};

export default TextBox;
